export function removePolishCharacters(str: string) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export function capitalizeFirstLetter(text: string) {
  return text.charAt(0).toUpperCase() + text.toLowerCase().slice(1);
}

export const normalizeString = (str: string): string =>
  removePolishCharacters(str)
    .toLowerCase()
    .replace(/[&/\\#,+()$~%.'":*?<>{}-]/g, "")
    .replace(/ł/g, "l");
